/**
 * @file dom相关配置文件
 * @param {Object} $tableEl 元素对象
 * @param {string} extra 额外的高度
 * @return {string} 返回的高度
 */

export function fixTableHeight($tableEl, extra = 0) {
    const tableTop = $tableEl.getBoundingClientRect().top;
    const clientHeight = window.innerHeight;
    return clientHeight - tableTop - extra;
}
